export default [
    {"text":" <div style='margin:auto; width: 180px;'><img src='/images/verstappen.png' alt='Max Verstappen Headshot' height=77px'/> vs <img src='/images/hamilton.png' alt='Lewis Hamilton Headshot' height=77px/></div><p>Max Verstappen’s title winning season started with a second place finish to rival Lewis Hamilton. <i>Lightning plots</i> allow us to experience some of the drama of the race through the lap data.",
        "selChart":"Lightning",
        "selRace":"Bahrain",
        "selDriver":"Max Verstappen",
        "button":"skipStory"
    },
    {"text":"Let's start with a single line. This represents Max Verstappen's cumulative lap times over the course of the race. The x-axis measures how far ahead or behind the average<sup style='line-height: 14px;'>*</sup> car a driver is. Drivers, like Verstappen, who are consistently faster than the average will move to the right as they get further ahead.<p><div class='footnote'><sup style='font-size:14px; line-height:12px;'>*</sup>We're using the median of cumulative lap times</div>",
        "selChart":"Lightning",
        "selRace":"Bahrain",
        "selDriver":"Max Verstappen",
        "intro":"Intro-1"
    },
    {"text":"Hover labels show time relative to the race leader. <p>Dips to the left <img src='/images/dip-left.png' alt='dip left example' height=17px/> like at laps 18 and 40 indicate slower laps usually because of a pitstop.",
        "selChart":"Lightning",
        "selRace":"Bahrain",
        "selDriver":"Max Verstappen",
        "intro":"Intro-1"
    },
    {"text":"Cars that are consitently slower than the average, like Mick Schumacher in his Haas vehicle, will move to the left of the chart as they fall further and further behind.",
        "selChart":"Lightning",
        "selRace":"Bahrain",
        "selDriver":"Mick Schumacher",
        "intro":"Intro-2"
    },
    {"text":"Fernando Alonso was trending only slightly slower than average in this race, but the truncated line indicates he was unable to finish, in this case because of brake problems on his car.",
        "selChart":"Lightning",
        "selRace":"Bahrain",
        "selDriver":"Fernando Alonso",
        "intro":"Intro-3"
    },
    {"text":"If we return the rest of the drivers to the chart we get a sense for the chaos of a race. Line intersections <img src='/images/intersection.png' alt='intersection example' height=17px/> show one driver overtaking another, often coinciding with a driver's pitstop.",
        "selChart":"Lightning",
        "selRace":"Bahrain",
        "selDriver":"Max Verstappen",
        "intro":"Bahrain"
    },
    {"text":"A narrowing of the field <img src='/images/narrowing.png' alt='narrowing example' height=17px/> like we see early in this race typically indicates a safety car being deployed or a red flag stopping the race for a time. These narrowings can sometimes be preceded by steep shifts to the right for cars ahead of the accident who can travel much faster than the now longer average time, and shifts to the left for those caught behind and slowed by it.",
        "selChart":"Lightning",
        "selRace":"Bahrain",
        "selDriver":"Max Verstappen",
        "intro": "Bahrain"
    },
    {"text":"If we look at Abu Dhabi, we can see these steep shifts and even see the impact of the controversial decision to only allow certain cars to unlap themselves after an accident with the resulting large gap between P6 & P7 and a subsequent gap between P11 & P12 at the season's final race in Abu Dhabi. Of course the chart doesn't tell us that is the reason, it more often prompts us to ask why.",
        "selChart":"Lightning",
        "selRace":"Abu Dhabi",
        "selDriver":"Max Verstappen"
    },
    {"text":"Use the dropdown to choose a race to plot. Hovering or tapping a line will give you details for the driver on that specific lap.",
        "selChart":"Lightning",
        "selRace":"Abu Dhabi",
        "selDriver":"Max Verstappen"
    },
    {"text":"While these plots expose some of the drama that unfolds in a race and hint at the many stories that exist across the field on any given race day, those dramas hit their peak at the checkered flag.",
        "selChart":"Lightning",
        "selRace":"Abu Dhabi",
        "selDriver":"Max Verstappen"
    },
    {"text":"When we focus on the race end with <i>Finish Traces</i>, we can see the clusters of drivers battling for those last points. Only the top ten drivers receive points toward the championship.",
        "selChart":"Finish",
        "selRace":"Abu Dhabi",
        "selDriver":"Max Verstappen"
    },
    {"text":"In Italy a saftey car on the track near race end meant the finish was tight between all the competitors, with Daniel Ricciardo clinching his first Grand Prix victory since 2018. Listening to a simulated finish allows us to hear just how close the racers were. Press the button above the chart or here to",
        "selChart":"Finish",
        "selRace":"Italy",
        "selDriver":"Daniel Ricciardo",
        "button":"simFinish"
    },
    {"text":"In Bahrain, Hamilton and Verstappen were less than a second apart, making for a thrilling finish, but the rest of the field is quite a ways behind. Hearing that finish in real-time emphasizes just how close the top two were relative to the rest.",
        "selChart":"Finish",
        "selRace":"Bahrain",
        "selDriver":"Lewis Hamilton",
    },
    {"text":"And all the individual race drama when put together made for a stunning championship battle. We can watch it unfold as each race Verstappen and Hamilton vie for supremacy, incredibly ending up tied before the final race of the season where Verstappen clinched the victory.",
        "selChart":"Places",
        "selRace":"Bahrain",
        "selDriver":"Lewis Hamilton",
    },
    {"text":"Hover or tap a bar to see the top finishers in the race. Points are given according to position.<p><img src='/images/points.svg' alt='First: 25 points, Second: 18 points, Third: 15 points, Fourth: 12 points, Fifth: 10 points, Sixth: 8 Points, Seventh: 6 points, Eighth: 4 points, Ninth: 2 points, Tenth: 1 point'/><p>Additional points are awarded for the fastest lap, <span style='color:#9CBCE0; font-size: 14px'>1 point</span>, and for sprint races associated with the events, <span style='color:#9CBCE0; font-size: 14px'>3, 2, & 1 points</span> to the top three finishers respectively. ",
        "selChart":"Places",
        "selRace":"Bahrain",
        "selDriver":"Lewis Hamilton",
    },
    {"text":"Use the buttons below to navigate between the charts, exploring the races further and spurring more questions about what happened on race days.",
        "selRace":"Bahrain",
        "selDriver":"Lewis Hamilton",
        "showNav":true
    },
]